import React from "react"
import PropTypes from "prop-types"
import Paper from "material-ui/Paper"
import RaisedButton from "material-ui/RaisedButton"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"

import CircularProgress from "material-ui/CircularProgress"
import { green500, blueGrey300, amber500 } from "material-ui/styles/colors"

import Name from "./Name"
import Address from "./Address"
import PersonalInfo from "./PersonalInfo"
import CitizenshipInfo from "./CitizenshipInfo"
import I9Progress from "../../I9Progress"
import strings from "../../../../localization/strings"
import TextField from "material-ui/TextField"

const utils = require("../../../../helpers/utils")
const api = require("../../../../api")
const i9Actions = require("../../../../actions/I9Actions")

const styles = {
    paper: {
        textAlign: "left",
        padding: 30,
        margin: 20
    },
    cardContainer: {
        textAlign: "center",
        width: "100%"
    }
}

const propTypes = {
    params: PropTypes.object
}

export default class Section1 extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            i9: null,
            step: 0,
            showProgress: true,
            name: "",
            showContinueButton: true,
            showBackButton: false,
            showFinishButton: false,
            nameValid: false,
            showConfirmSubmit: false,
            showConfirm: false
        }

        this.onProgressClick = this.onProgressClick.bind(this)
        this.onValueChange = this.onValueChange.bind(this)
        this.onFinishClick = this.onFinishClick.bind(this)
        this.onBackClick = this.onBackClick.bind(this)
        this.onNextClick = this.onNextClick.bind(this)
        this.onSubmitConfirm = this.onSubmitConfirm.bind(this)
        this.onCloseConfirm = this.onCloseConfirm.bind(this)
    }

    componentDidMount() {
        document.title = `I9 | ${strings.Findd_Grandd_Central}`
        const _this = this

        i9Actions.loadSection1Data(this.props.params.shortCode).then(function(result) {
            //Mark whether SSN has changed.
            result.SSNChanged = false
            _this.setState({
                i9: result,
                showProgress: false,
                name: _this.getName(),
                validArray: _this.getValidArray(result)
            })
        })
    }

    getName() {
        return this.state.i9 ? this.state.i9.Employee_FirstName + " " + this.state.i9.Employee_LastName : ""
    }

    onNextClick() {
        const nextStep = this.state.step + 1
        const validArray = this.getValidArray(this.state.i9)
        this.setState({
            step: nextStep,
            showContinueButton: nextStep < 3,
            showBackButton: nextStep !== 0,
            validArray: validArray,
            showFinishButton: this.getShowFinishButton(nextStep, validArray)
        })
    }

    onBackClick() {
        let nextStep = this.state.step - 1
        if (nextStep < 0) nextStep = 0

        const validArray = this.getValidArray(this.state.i9)

        this.setState({
            step: nextStep,
            showContinueButton: nextStep < 3,
            showBackButton: nextStep !== 0,
            validArray: validArray,
            showFinishButton: this.getShowFinishButton(nextStep, validArray)
        })
    }

    onValueChange(updatedI9) {
        const validArray = this.getValidArray(updatedI9)
        const _this = this

        this.setState(
            {
                i9: updatedI9,
                validArray: validArray,
                showFinishButton: this.getShowFinishButton(this.state.step, validArray)
            },
            () => {
                _this.setState({
                    name: _this.getName()
                })
            }
        )
    }

    getShowFinishButton(step, validArray) {
        return step === 3 && validArray[0] && validArray[1] && validArray[2] && validArray[3]
    }

    getValidArray(i9) {
        return [this.refs.name.validate(i9), this.refs.address.validate(i9), this.refs.personalInfo.validate(i9), this.refs.citizenshipInfo.validate(i9)]
    }

    onProgressClick(index) {
        const validArray = this.getValidArray(this.state.i9)
        this.setState({
            step: index,
            showContinueButton: index < 3,
            showBackButton: index !== 0,
            validArray: validArray,
            showFinishButton: this.getShowFinishButton(this.state.step, validArray)
        })
    }

    onFinishClick() {
        this.setState({
            showConfirmSubmit: true
        })
    }

    onCloseConfirm() {
        this.setState({
            showConfirmSubmit: false
        })
    }

    onSubmitConfirm() {
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            markSection1Complete: true
        })
        this.setState({
            showConfirmSubmit: false,
            showConfirm: true
        })
    }

    render() {
        return (
            <div className="Section1" style={{ textAlign: "center", marginTop: -100 }}>
                {!this.state.showConfirm && (
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: 12,
                            color: "white",
                            backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor,
                            padding: 5
                        }}
                    >
                        USCIS Form I-9 Section 1 Data <span style={{ color: blueGrey300 }}>{this.state.name}</span>
                    </div>
                )}
                {this.state.showProgress && (
                    <div style={{ padding: 20 }}>
                        <div style={{ paddingBottom: 20 }}>Loading your information, please wait...</div>
                        <CircularProgress />
                    </div>
                )}

                {!(this.state.showProgress || this.state.showConfirm) && (
                    <div
                        style={{
                            padding: 10,
                            maxWidth: 800,
                            margin: "0px auto"
                        }}
                    >
                        <p style={{ textAlign: "left" }}>
                            <b>Required Information</b>
                            <br />
                            In preparation to fill out section 1 of your I-9 Form, it is required that your personal information is confirmed.
                        </p>
                        <br />
                        <I9Progress step={this.state.step} validArray={this.state.validArray} onClick={this.onProgressClick} />
                        <br />

                        {this.state.step === 0 && (
                            <div
                                style={{
                                    width: "100%",
                                    display: "inline-block"
                                }}
                            >
                                <Name i9={this.state.i9} onValueChange={this.onValueChange} ref="name" />
                            </div>
                        )}
                        {this.state.step === 1 && (
                            <div
                                style={{
                                    width: "100%",
                                    display: "inline-block"
                                }}
                            >
                                <Address i9={this.state.i9} onValueChange={this.onValueChange} ref="address" />
                            </div>
                        )}
                        {this.state.step === 2 && (
                            <div
                                style={{
                                    width: "100%",
                                    display: "inline-block"
                                }}
                            >
                                <PersonalInfo i9={this.state.i9} onValueChange={this.onValueChange} ref="personalInfo" />
                            </div>
                        )}
                        {this.state.step === 3 && (
                            <div
                                style={{
                                    width: "100%",
                                    display: "inline-block"
                                }}
                            >
                                <CitizenshipInfo i9={this.state.i9} onValueChange={this.onValueChange} ref="citizenshipInfo" />
                            </div>
                        )}

                        <div style={{ marginTop: 20 }}>
                            {this.state.showFinishButton && (
                                <RaisedButton
                                    label="FINISH I9 SECTION 1"
                                    icon={
                                        <i
                                            className="fa fa-arrow-circle-right"
                                            style={{
                                                fontSize: 25,
                                                marginTop: -10,
                                                marginLeft: -20,
                                                color: "#ffffff"
                                            }}
                                        />
                                    }
                                    labelPosition="before"
                                    secondary={false}
                                    backgroundColor="#4CAF50"
                                    onClick={this.onFinishClick}
                                    style={{
                                        marginLeft: 20,
                                        height: 50,
                                        display: "inline-block"
                                    }}
                                    labelStyle={{
                                        fontSize: 20,
                                        margin: 20,
                                        color: "#ffffff"
                                    }}
                                />
                            )}
                        </div>
                        <div style={{ paddingTop: 20, marginBottom: 40 }}>
                            {this.state.showBackButton && <RaisedButton label="BACK" primary={true} secondary={false} onClick={this.onBackClick} style={{ display: "inline-block" }} />}
                            {this.state.showContinueButton && (
                                <RaisedButton
                                    label="CONTINUE"
                                    secondary={false}
                                    onClick={this.onNextClick}
                                    style={{
                                        marginLeft: 20,
                                        display: "inline-block"
                                    }}
                                />
                            )}
                        </div>
                    </div>
                )}

                {this.state.showConfirm && (
                    <div style={{ paddingTop: 100 }}>
                        <h2>Thank you {this.state.i9 ? this.state.i9.Employee_FirstName : ""}.</h2>
                        <p>Form I9 Section 1 has been submitted to your employer.</p>
                        <i className="fa fa-check-circle" style={{ color: green500, fontSize: 150 }} />
                    </div>
                )}
                <Dialog
                    title={"Submit Information?"}
                    actions={[<FlatButton label="Submit" primary={true} onTouchTap={this.onSubmitConfirm} />, <FlatButton label={strings.Cancel} secondary={true} onTouchTap={this.onCloseConfirm} />]}
                    modal={true}
                    open={this.state.showConfirmSubmit}
                >
                    Are you ready to send I9 section 1 data to your employer?
                </Dialog>
            </div>
        )
    }
}

Section1.propTypes = propTypes
